import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { InspectionItemCodeCategory } from 'src/app/rgs/components/objects/object-item/object-inspection/models/inspection-item-code.model';
import { CompanyOwned } from '../company/company-models.model';
import { ElementGroupCode } from '../element/element-group-code.model';
import { InspectionLabelListCodeStage } from './inspection-list-item-stage-code.model';
import { InspectionMethodCode } from './inspection-method-code.model';

@HateoasResource('inspectionitemcode')
export class InspectionListItemCode extends CompanyOwned {
  public categorie!: InspectionItemCodeCategory;
  public groep_id!: string;
  public groep_description!: string;
  public methode!: string;
  public naam!: string;
  public stadia!: InspectionLabelListCodeStage[];
  public verborgen!: boolean;
  public required = false;

  //FRONTEND ONLY
  public groepResolved?: ElementGroupCode;
  public methodeResolved?: InspectionMethodCode;
  public defaultRemarks: DefaultRemark[] = [];
}

export class DefaultRemark {
  public index!: number;
  public remark!: string;

  //frontend only
  public editing?: boolean = false;
}
